import React, { useState } from "react";
import { Gauge, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { measureDownload, measurePing, measureUpload, renderResultImage } from "../lib/speedtest";

const PHASES = { ping: "Misuro il ping…", download: "Misuro il download…", upload: "Misuro l'upload…", save: "Salvo l'immagine…" };

export const SpeedTestPanel = ({ clientName, onResult }) => {
  const [phase, setPhase] = useState(null);
  const [live, setLive] = useState(null);
  const [res, setRes] = useState({});

  const run = async () => {
    if (!navigator.onLine) { toast.error("Nessuna connessione: collegati al WiFi del cliente"); return; }
    setRes({}); setLive(null);
    try {
      setPhase("ping");
      const ping = await measurePing();
      setRes({ ping });
      setPhase("download");
      const download = await measureDownload(8, 4, setLive);
      setRes({ ping, download }); setLive(null);
      setPhase("upload");
      const upload = await measureUpload(6, 3, setLive);
      setRes({ ping, download, upload }); setLive(null);
      setPhase("save");
      const blob = await renderResultImage({ download, upload, ping, clientName, when: new Date() });
      const stamp = new Date().toISOString().slice(0, 16).replace(/[-:T]/g, "");
      await onResult(new File([blob], `SpeedTest_${stamp}.jpg`, { type: "image/jpeg" }), { download, upload, ping });
      toast.success(`Speed test: ${download.toFixed(1)} ↓ / ${upload.toFixed(1)} ↑ Mbps · ping ${Math.round(ping)} ms`);
    } catch (e) {
      toast.error(`Speed test non riuscito: ${e.message || "errore di rete"}`);
    } finally { setPhase(null); setLive(null); }
  };

  const v = (k, unit) => (res[k] != null ? `${res[k].toFixed(k === "ping" ? 0 : 1)} ${unit}` : phase === k && live != null ? `${live.toFixed(1)} ${unit}` : "—");

  return (
    <div className="mb-3 p-3 rounded-md border flex flex-wrap items-center gap-3" style={{ borderColor: "var(--border)", background: "#F8FAFC" }} data-testid="speedtest-panel">
      <button type="button" onClick={run} disabled={!!phase} className="btn-primary disabled:opacity-60" data-testid="speedtest-start">
        {phase ? <Loader2 className="w-4 h-4 animate-spin" /> : <Gauge className="w-4 h-4" />} {phase ? PHASES[phase] : "Avvia speed test"}
      </button>
      <div className="flex gap-4 text-sm" data-testid="speedtest-results">
        <span>↓ <b data-testid="speedtest-download">{v("download", "Mbps")}</b></span>
        <span>↑ <b data-testid="speedtest-upload">{v("upload", "Mbps")}</b></span>
        <span>Ping <b data-testid="speedtest-ping">{v("ping", "ms")}</b></span>
      </div>
      <div className="text-[11px] w-full" style={{ color: "var(--text-muted)" }}>Collega il telefono al WiFi del cliente. A fine test l'immagine con i risultati viene salvata qui sotto.</div>
    </div>
  );
};
